export default __webpack_public_path__ + "static/media/anesthesia.970a0ea4.jpg";